// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WyDCL","question":"styles_question__chpkn","inputVisibleButton":"styles_inputVisibleButton__2nx7o","note":"styles_note__x7E7j"};